import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class MoleculesFavoriteIconComponent extends Component {
  @service favorite;

  get isFavorite() {
    return this.args?.params?.model?.favorite;
  }

  get modelName() {
    return this.args.params.model.get('constructor.modelName');
  }
  @action
  addToFavorite() {
    this.favorite.addToFavorite(this.args?.params?.model, this.modelName);
  }

  @action
  removeFromFavorite() {
    this.favorite.removeFromFavorite(this.args?.params?.model, this.modelName);
  }
}
